<template>
  <div class="item-main" :style="height?'height:'+height+'px;':''">
    <div class="item-list">
      <div class="item-left">
        <a class="item-left-list" v-for="(item,index) in newList" :key="index"
             :style="selectLeftIndex==index?'color:'+themeColor+';background: #FFFFFF':''"
             @click.stop="selectLeft(index)">{{ item.name }}
        </a>
      </div>
      <div class="item-right">
        <div v-if="newList[selectLeftIndex] && newList[selectLeftIndex].childs.length>0" style="width: 100%;">
          <a class="item-right-list" v-for="(mess,inx) in newList[selectLeftIndex].childs" :key="inx"
               @click.stop="selectRight(mess)">
            <div class="item-right-list-name" :style="mess.chooseState?'color:'+themeColor:''">
              {{ mess.name }}
            </div>
            <img v-if="mess.chooseState" class="item-right-list-img" src="https://www.mgadmob.com/mp/img/selected.png">
            <img v-else class="item-right-list-img" src="https://www.mgadmob.com/mp/img/noselected.png">
          </a>
        </div>
        <div class="no-data" v-else>暂无数据</div>
      </div>
    </div>
    <div class="btn-list">
      <a class="btn-reset" @click.stop="reset">重置</a>
      <a class="btn-complete" :style="'background: '+themeColor" @click.stop="complete">完成</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //数据源
    itemList: {
      type: Array,
      default: () => {
        return []
      }
    },
    //是否多选
    isMultiple: {
      type: Boolean,
      default: false
    },
    //主题色
    themeColor: {
      type: String,
      default: '#62BF99',
    },
  },
  data() {
    return {
      selectLeftIndex: 0,
      height: 0,
      newList: []
    }
  },
  watch: {
    itemList: {
      deep: true,
      immediate: true,
      handler(newArr) {
        if (newArr.length) {
          this.newList = newArr
        }
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.itemList.length >= this.itemList[0].childs.length) {
        this.height = this.itemList.length * 72 + 108
      } else {
        this.height = this.itemList[0].childs.length * 72 + 108
      }
    })
  },
  methods: {
    selectLeft(index) {
      this.selectLeftIndex = index
      if (this.newList.length >= this.newList[this.selectLeftIndex].childs.length) {
        this.height = this.newList.length * 72 + 108
      } else {
        this.height = this.newList[this.selectLeftIndex].childs.length * 72 + 108
      }
    },
    selectRight(item) {
      if (!this.isMultiple) this.initial()
      item.chooseState = !item.chooseState
      this.newList = JSON.parse(JSON.stringify(this.newList))
    },
    initial() {
      this.newList.forEach(res => {
        res.childs.forEach(item => {
          item.chooseState = false
        })
      })
    },
    //重置
    reset() {
      this.initial()
      this.newList = JSON.parse(JSON.stringify(this.newList))
    },
    //完成
    complete() {
      this.$emit('complete', {
        type: 1,
        list: this.newList
      })
    },
  }
}
</script>
<style>
.item-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 60vh;

  .item-list {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .item-left {
      width: 180px;
      height: 100%;
      overflow-y: auto;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;

      .item-left-list {
        box-sizing: border-box;
        padding: 10px 0px 10px 20px;
        width: 100%;
        height: 40px;
        background: #F4F4F4;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 16px;
        color: #383838;
      }
    }

    .item-right {
      width: 200px;
      height: 100%;
      display: flex;
      overflow-y: auto;
      background: white;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;

      .item-right-list {
        width: 100%;
        box-sizing: border-box;
        height: 40px;
        display: flex;
        text-align: left;
        justify-content: space-between;
        padding: 10px 20px 10px 20px;

        .item-right-list-name {
          font-size: 16px;
          color: #333333;
        }

        .item-right-list-img {
          width: 18px;
          height: 18px;
        }
      }

      .no-data {
        width: 100%;
        height: 100%;
        font-size: 16px;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .btn-list {
    background: #FEFFFE;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-around;
    padding: 15px 0px;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;

    .btn-reset {
      padding: 3px 50px;
      background: #FFFFFF;
      border-radius: 40px;
      border: 1px solid #E6E6E6;
      font-size: 16px;
      color: #3E3E3E;
    }

    .btn-complete {
      border-radius: 40px;
      padding: 3px 50px;
      font-size: 16px;
      color: #FFFFFF;
    }
  }
}
</style>
